module.exports = __webpack_public_path__ + "static/img/26.04808e64.png";